import React, { useState } from "react";
import { Box, Button, Typography, TextField, IconButton } from "@mui/material";
import {
	verifyOTP,
	loginWithOTP,
	RegistrationOTP,
	mobialLogin,
	getProfileDetails,
} from "../../../services/operations/userOperations";
import CustomAlert from "../../common/CustomAlert";
import Loader from "../../common/Loader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const OTPScreen = ({ phoneNumber, onSubmit, onBack, isLoginOTP = false }) => {
	const [otp, setOtp] = useState(["", "", "", "", "", ""]);
	const [loading, setLoading] = useState(false);
	const [alert, setAlert] = useState({
		open: false,
		message: "",
		severity: "success",
	});

	const handleChange = (index, value) => {
		if (isNaN(value)) return;

		const newOtp = [...otp];
		newOtp[index] = value;
		setOtp(newOtp);

		// Auto focus to next input
		if (value !== "" && index < 5) {
			const nextInput = document.getElementById(`otp-${index + 1}`);
			if (nextInput) nextInput.focus();
		}
	};
	const buttonStyles = {
		height: { xs: "42px", sm: "48px" },
		backgroundColor: "#C1721F",
		// "#c87629"
		color: "white",
		textTransform: "none",
		fontWeight: 600,
		fontSize: { xs: "16px", sm: "18px" },
		padding: { xs: "10px", sm: "14px" },
		borderRadius: "8px",
		"&:hover": {
			backgroundColor: "rgba(204, 185, 16, 0.5) ",
			color: "black"
		},
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const otpValue = otp.join("");
			const verifyFn = isLoginOTP ? loginWithOTP : RegistrationOTP;

			const response = await verifyFn({
				mobile: phoneNumber,
				otp: otpValue,
			});

			if (!response.status) {
				setAlert({
					open: true,
					message: response.message || "Invalid OTP",
					severity: "error",
				});
				return;
			}

			// Store token and redirect
			if (response.token) {
				localStorage.setItem("token", response.token);
				const profileData = await getProfileDetails();
				if (profileData.status) {
					localStorage.setItem("profileData", JSON.stringify(profileData.data));
					if(profileData?.profileStrenth >= 60){
						window.location.href = "/profile/DetaliesDashbord?type=suggested-profiles";
					}
				}
				
				setAlert({
					open: true,
					message: "OTP Verification successful",
					severity: "success",
				});

				setTimeout(() => {
					onSubmit(response.token);
					window.location.href = "/profile/personal-details";
				}, 1000);
			}
		} catch (err) {
			setAlert({
				open: true,
				message: err.message || "OTP verification failed",
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box sx={{ width: "100%", position: "relative" }}>
			<CustomAlert {...alert} />
			{loading ? (
				<Loader />
			) : (
				<Box sx={{ width: "100%" }}>
					{onBack && (
						<IconButton
							onClick={onBack}
							sx={{
								position: "absolute",
								top: -15,
								left: -20,
								zIndex: 1000,
								color: "#666",
								"&:hover": {
									backgroundColor: "rgba(0, 0, 0, 0.04)",
								},
							}}
						>
							<ArrowBackIcon />
						</IconButton>
					)}
					<Typography
						variant="h6"
						component="h2"
						align="center"
						sx={{
							mt: 4,
							mb: 3,
							fontSize: { xs: "14px", sm: "16px" },
						}}
					>
						Please enter the 6-digit code sent to {phoneNumber}
					</Typography>

					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 3,
						}}
					>
						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								gap: { xs: 1, sm: 2 },
							}}
						>
							{otp.map((digit, index) => (
								<TextField
									key={index}
									id={`otp-${index}`}
									value={digit}
									onChange={(e) => handleChange(index, e.target.value)}
									inputProps={{ maxLength: 1 }}
									sx={{ width: "50px", height: "50px", textAlign: "center" }}
									InputProps={{
										sx: { fontSize: "24px", textAlign: "center" },
									}}
								/>
							))}
						</Box>

						<Button
							fullWidth
							variant="contained"
							onClick={handleSubmit}
							// sx={{ mt: 3, py: 1.5 }}
							sx={buttonStyles}

						>
							Verify OTP
						</Button>
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default OTPScreen;
